import React from 'react';
import s from './s.module.less';

// data-wiz-section-header 供 ReviewSection 内联编辑时按属性选择器隐藏与卡片标题重复的首个 section 标题
export default function SectionHeader({ title, action }: { title: React.ReactNode; action?: React.ReactNode }) {
    return (
        <div className={s.header} data-wiz-section-header>
            <span className={s.title}>{title}</span>
            {action}
        </div>
    );
}
